<template>
	<div>
		<v-text-field
			:label="getAttributeTitle('MaxInteractiveAtlas')"
			hide-details
			v-model="maxInteractiveAtlases"
			filled
			class="mt-2"
			:rules="rules"
			type="number"
			:key="getKey('maxInteractiveAtlases')"
		></v-text-field>
		<v-text-field
			:label="getAttributeTitle('MaxPrintAtlas')"
			hide-details
			v-model="maxPrintableAtlases"
			filled
			class="mt-2"
			:rules="rules"
			type="number"
			:key="getKey('maxPrintableAtlases')"
		></v-text-field>
		<v-text-field
			:label="getAttributeTitle('MaxMb')"
			hide-details
			v-model="maxMb"
			filled
			class="mt-2"
			:rules="rules"
			type="number"
			:key="getKey('maxMb')"
		></v-text-field>
	</div>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";

	export default {
		data: function(){
			var data = {
				maxInteractiveAtlases: null,
				maxPrintableAtlases: null,
				maxMb: null,
				rules: [v => !!v || "Laukas privalomas"]
			};
			if (this.values) {
				data.maxInteractiveAtlases = this.values["MaxInteractiveAtlas"];
				data.maxPrintableAtlases = this.values["MaxPrintAtlas"];
				data.maxMb = this.values["MaxMb"];
			}
			return data;
		},
		props: {
			values: Object
		},
		methods: {
			getKey: function(key){
				key = key + "-" + this.iteration;
				return key;
			},
			getAttributeTitle: function(key){
				return AdminHelper.getAttributeTitle(key);
			}
		}
	}
</script>